import { MatchEvent } from "../matchEvent";
import { EventName } from "../enums/eventName";

// REFSIX-647: a match suspended mid-period (e.g. lightning). timestamp is when
// play stopped; endTime is when the referee resumed the clock, absent while the
// match is still suspended. The time between the two is excluded from match
// time: minuteOfPlay of every later event is recorded as if it never happened.
export class SuspensionEvent extends MatchEvent {
    endTime?: number;

    constructor(
        timestamp: number,
        eventName: EventName,
        half: number,
        minuteOfPlay: number,
        endTime?: number
    ) {
        super(timestamp, eventName, half, minuteOfPlay);
        this.endTime = endTime;
    }

    static fromJSON(
        json: Pick<
            SuspensionEvent,
            "timestamp" | "eventName" | "half" | "minuteOfPlay" | "endTime"
        >
    ) {
        return new SuspensionEvent(
            json.timestamp,
            json.eventName,
            json.half,
            json.minuteOfPlay,
            json.endTime
        );
    }
}
